"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _moment = _interopRequireDefault(require("moment"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DayBlock = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 16px;\n  cursor: pointer;\n\n  &.muted {\n    color: rgba(0, 0, 0, 0.3);\n  }\n\n  &.active {\n    font-weight: 700;\n    background-color: rgba(182, 112, 244, 0.05);\n    border-radius: var(--radius);\n  }\n\n  &.start,\n  &.end {\n    background-color: #2baca4;\n    color: #fff;\n    z-index: 999;\n  }\n\n  &.start {\n    border-radius: 50px;\n  }\n\n  &.end {\n    border-radius: 50px;\n  }\n\n  &.start.end {\n    border-radius: 50px;\n  }\n\n  &.between {\n    border-radius: 0;\n    background-color: #e6f5f4;\n    color: #000;\n    width: 140%;\n    margin-left: -10px;\n    position: relative;\n    z-index: 0;\n  }\n\n  &.between:nth-child(7n):after,\n  &.start:nth-child(7n):after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 100%;\n    background-color: var(--primary);\n    width: 20px;\n  }\n\n  &.between:nth-child(7n + 1):after,\n  &.end:nth-child(7n + 1):after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 100%;\n    background-color: var(--primary);\n    width: 20px;\n  }\n\n  &.start.end:after {\n    display: none;\n  }\n"])));
var momentPropType = function momentPropType(props, propName, componentName) {
  if (!_moment["default"].isMoment(props[propName])) {
    return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`. Expected a Moment object."));
  }
};
function Day(_ref) {
  var date = _ref.date,
    currentDate = _ref.currentDate,
    startDate = _ref.startDate,
    endDate = _ref.endDate,
    onClick = _ref.onClick;
  var day = date.day;
  var isActive = (0, _moment["default"])().isSame(day, 'day');
  var isStart = day.isSame(startDate, 'day');
  var isBetween = day.isBetween(startDate, endDate, 'day');
  var isEnd = day.isSame(endDate, 'day');
  var isMuted = !day.isSame(currentDate, 'month');
  var dayClassNames = (0, _classnames["default"])({
    active: isActive,
    start: isStart,
    between: isBetween,
    end: isEnd,
    muted: isMuted
  });
  return /*#__PURE__*/_react["default"].createElement(DayBlock, {
    className: dayClassNames,
    onClick: onClick
  }, day.date());
}
Day.propTypes = {
  date: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    day: _propTypes["default"].instanceOf(_moment["default"]).isRequired
  }).isRequired,
  currentDate: _propTypes["default"].instanceOf(_moment["default"]),
  startDate: _propTypes["default"].instanceOf(_moment["default"]),
  endDate: _propTypes["default"].instanceOf(_moment["default"]),
  onClick: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(Day);